<template>
  <modal
    class="club-modal"
    :visible="isClubModalShown"
    full-screen
    @on-close="closeModal"
  >
    <div class="club-modal__title">
      Клубная карта
    </div>
    <club-modal-content
      v-if="isClubModalShown"
      class="club-modal__content"
    />
  </modal>
</template>

<script setup lang="ts">
import { defineAsyncComponent } from 'vue';

import { useClubModal } from './useClubModal';

const ClubModalContent = defineAsyncComponent(() => import('./club-modal-content.vue'));

const { isClubModalShown, closeModal } = useClubModal();

</script>

<style lang="scss">
.club-modal {

  &.modal {
    @include stacking('club-modal');
  }

  &__title {
    height: 48px;
    font-family: Gilroy, sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 48px;
    text-align: center;
    margin-bottom: 10px;
  }

  &__content {
    padding: 0 16px 16px;
  }
}
</style>
